package ai.wagemix.net.models

import kotlin.time.Instant

/** The signed-in Firebase user as the site sees it; `null` in the session flow means signed out. */
interface WMSession {
    val uid: String
    val email: String
    val emailVerified: Boolean
    val displayName: String?
    /** When the account was created, as the identity provider reports it; `null` when it does not. */
    val createdAt: Instant?

    companion object
}

fun WMSession.Companion.of(
    uid: String,
    email: String,
    emailVerified: Boolean,
    displayName: String?,
    createdAt: Instant? = null,
): WMSession {
    return WMSessionData(uid, email, emailVerified, displayName, createdAt)
}

private data class WMSessionData(
    override val uid: String,
    override val email: String,
    override val emailVerified: Boolean,
    override val displayName: String?,
    override val createdAt: Instant?
): WMSession

/** Why an authentication step failed; the UI maps each reason to copy. */
enum class WMAuthFailure {
    InvalidCredentials,
    UserAlreadyExists,
    WeakPassword,
    InvalidEmail,
    TooManyAttempts,
    ExpiredLink,
    InvalidLink,
    AccountNotFound,
    Network,
    Unknown
}

/** The outcome of an authentication step. */
sealed interface WMAuthResult {
    data class Success(val session: WMSession): WMAuthResult
    data class Failure(val reason: WMAuthFailure, val message: String?): WMAuthResult
}
